var render = function render(){var _vm=this,_c=_vm._self._c;return _c('span',{staticClass:"score-placeholder"},[_c('eg-icon',{staticClass:"score-placeholder__arrow",attrs:{"icon":"arrow-right"}}),_c('span',{staticClass:"score-placeholder__bubble"},[_vm._v("—")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }